import { jsxs, jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import '../ui/button.js';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

const STATUS_STYLES = {
    published: { pill: 'bg-emerald-400/15 text-emerald-400', dot: 'bg-emerald-400' },
    draft: { pill: 'bg-amber-400/15 text-amber-400', dot: 'bg-amber-400' },
    needs_review: { pill: 'bg-red-400/15 text-red-400', dot: 'bg-red-400' },
};
const DEFAULT_LABELS = {
    needs_review: 'Needs Review',
};
/**
 * Small status pill with a colored dot and label, used on dark hero banners
 * to indicate publication state (`published`, `draft`, `needs_review`).
 *
 * Unknown statuses fall back to a neutral gray styling and the raw status
 * string as the label.
 */
function StatusPill({ status, label, className }) {
    const styles = STATUS_STYLES[status] ?? { pill: 'bg-white/10 text-white/70', dot: 'bg-white/40' };
    const resolvedLabel = label ?? DEFAULT_LABELS[status] ?? status;
    return (jsxs("span", { className: cn('inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-normal uppercase tracking-wider', styles.pill, className), children: [jsx("span", { className: cn('h-2 w-2 rounded-full', styles.dot) }), resolvedLabel] }));
}

export { StatusPill };
//# sourceMappingURL=StatusPill.js.map
